var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("©2008–2020 Red Medicine Pty Ltd, ")]),_c('p',[_vm._v("trading as Red Health Independent Medical Assessments")]),_c('p',[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy")]),_vm._v("    "),_c('a',{attrs:{"href":"https://redhealth.com.au/privacy-policy/","target":"_blank"}},[_vm._v("Terms of Use")])])])
}]

export { render, staticRenderFns }